
import {
  ButtonText,
  ExitStaffConstants,
  PlaceHolderText,
  StaffListConstants,
} from "../../constants/constants";
import { UserExitFLowTitleComponent } from "./UserExitFLowTitleComponent";
import { UserExitProfileFLow } from "./UserExitProfileFlow";
import Input from "./cta/Input";
import {
  exitStaffAsync,
  fetchReasonForExitListAsync,
} from "../../store/thunks/staffListThunk";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { useEffect, useState } from "react";
import { formatDateInput } from "../../utils/DataTime";
import Button from "./cta/Button";
import { useNavigate, useParams } from "react-router-dom";
import { fetchUserDetailsAsync } from "../../store/thunks/userThunk";
import { STATUS } from "../../store/slices/userDetailslice";
import LoaderPopupModel from "./LoaderPopup";
import PopupModal from "./PopupModal";
import { PopupMessage } from "./SideMenuStaffVerification";
import { resetExitStaffStatus } from "../../store/slices/staffListSlice";
import Dropdown from "./cta/Dropdown";
import { useTranslation } from "react-i18next";

export const UserExitFLowComponent = () => {
  const navigate = useNavigate();
  const {t,i18n}=useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const staffListData = useSelector((state: RootState) => state.staffListData);
  const exitStaffStatus = useSelector(
    (state: RootState) => state.staffListData.exitStaffStatus
  );
  const exitStaffErrorMessage = useSelector(
    (state: RootState) => state.staffListData.exitStaffErrorMessage
  );
  const [exitReasonsOptions, setExitReasonsOptions] = useState<any[]>([]);
  const [selectedExpiryDate, setSelectedExpiryDate] = useState<string | null>(
    null
  );
  const { userid } = useParams<{ userid: string }>();
  const [additionalComments, setAdditionalComments] = useState<string|null>(null);
  const [otherOptionSelected, setOtherOptionSelected] =
    useState<boolean>(false);
  const [selectedReason, setSelectedReason] = useState<string | null>(null);
  const [isExitStaffLoading, setExitStaffLoading] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpMsg, setPopUpMsg] = useState<PopupMessage>({
    title: "",
    message: "",
  });
  const [showError, setShowErrorForComments] = useState<boolean>(false);
  useEffect(() => {
    if (exitStaffStatus == STATUS.LOADING) {
      setExitStaffLoading(true);
      setShowPopUp(false);
    }
    if (exitStaffStatus === STATUS.SUCCESS) {
      setPopUpMsg({
        title: t('staffExitSuccessMessage1'),
        message: t('staffExitSuccessMessage2'),
      });
      setExitStaffLoading(false);

      setShowPopUp(true);
    }
    if (exitStaffStatus === STATUS.FAILED) {
      setPopUpMsg({
        title: exitStaffErrorMessage ?? "",
        message: "",
      });
      setShowPopUp(true);

      setExitStaffLoading(false);
    }
  }, [exitStaffStatus, exitStaffErrorMessage]);
  useEffect(() => {
    setExitReasonsOptions(
      staffListData.exitReasonObj?.exitReasons.map(
        (reasonObj) => reasonObj.reason
      ) ?? []
    );
  }, [staffListData.exitReasonObj]);

  useEffect(() => {
    dispatch(fetchUserDetailsAsync(userid ?? ""));
    dispatch(fetchReasonForExitListAsync());
  }, []);

  useEffect(() => {
    setShowErrorForComments(false);
    if (selectedReason === ExitStaffConstants.other) {
      setOtherOptionSelected(true);
    } else {
      setOtherOptionSelected(false);
    }
    setAdditionalComments("");
  }, [selectedReason]);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { name, value }: any = e.target;
    let dateValue = new Date(value);
    if (!isNaN(dateValue.getTime())) {
      setSelectedExpiryDate(value.split("-").join("/"));
    }
  };

  const handleSelectChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    let { value }: any = e.target;
    const selectedReason = staffListData.exitReasonObj?.exitReasons.find(
      (reasonObj) => reasonObj.reason === value
    );

    setSelectedReason(selectedReason?.reason ?? "");
  };
  const handleAdditionalCommentsChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowErrorForComments(false);
    setAdditionalComments(e.target.value);
  };

  const handleCancel = () => {
    navigate("/dashboard");
  };
  const handleSumbit = () => {
    if (selectedReason === ExitStaffConstants.other &&  additionalComments==="") {
      setShowErrorForComments(true);
    } else {
      setShowErrorForComments(false);
      const data = {
        lastWorkingDate: selectedExpiryDate,
        reason: selectedReason,
        comment: additionalComments ?? "",
      };

      dispatch(exitStaffAsync({ userId: userid, data: data }));
    }
    
  };
  const closePopup = () => {
    if(exitStaffStatus === STATUS.SUCCESS){
      navigate("/dashboard");
    }
    dispatch(resetExitStaffStatus());
    setShowPopUp(false);
  };
  return (
    <>
      {isExitStaffLoading && <LoaderPopupModel isOpen={isExitStaffLoading} />}
      <div className="justify-space-between flex flex-col">
        <div className="pl-[4vw] pt-2 py-8 pr-[4vw]">
          <UserExitFLowTitleComponent />
          <div className="bg-whiteColor rounded  mt-8 ">
            <UserExitProfileFLow />

            <hr className=" my-6 bg-dividerColor h-[1px] "></hr>

            <div className="flex flex-col md:flex-row gap-4 pt-4   ">
              <div className="md:w-1/3 w-full relative">
                <Input
                  type="date"
                  name="lastWorkingDate"
                  value={
                    selectedExpiryDate
                      ? formatDateInput(selectedExpiryDate)
                      : ""
                  }
                  onKeyDown={(e: any) => {
                    e.preventDefault();
                  }}
                  label={t('lastWorkingDay')}
                  handleOnChange={handleDateChange}
                  placeholder={t('selectTheLastWorkingDay')}
                  isDateOfBirth={false}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
              <div className="md:w-1/3 w-full">
                <Dropdown
                  data-testid="reason-dropdown"
                  value={selectedReason ?? ""}
                  name="reasonForExit"
                  handleOnChange={handleSelectChange}
                  placeholder={t('selectReasonForExit')}
                  label={t('reasonForExit')}
                  options={exitReasonsOptions}
                  borderColor={"border-sideMenuHelpBox"}
                />
              </div>

              <div className="md:w-1/3 w-full">
                <Input
                  disabled={!otherOptionSelected}
                  type="text"
                  name="others"
                  value={additionalComments??""}
                  placeholder={t('additionalComments')}
                  handleOnChange={handleAdditionalCommentsChange}
                  label={t('otherReason')}
                  borderColor={
                    showError && additionalComments === ""
                      ? "border-redColor"
                      : "border-sideMenuHelpBox"
                  }
                />
                {showError && (
                  <div className="text-redColor text-xs pt-1">
                    {t('additionalCommentErrorMessage')}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="flex md:justify-end justify-center mt-12 gap-4 md:pr-[4vw]">
          <Button
            handleClick={handleCancel}
            buttonText={t('cancel')}
            className={
              "py-2 px-9  mb-2 downloadSampleConsentText font-nunito text-primary border  border-primary bg-whiteColor rounded-lg"
            }
          />{" "}
          <Button
            buttonText={t('confirmAndSubmit')}
            handleClick={handleSumbit}
            className="py-2 md:px-8 px-4 mb-2 downloadSampleConsentText text-white font-nunito  bg-primary rounded-lg"
          />
        </div>
      </div>
      {showPopUp && (
        <PopupModal
          popUpTitle={popUpMsg.title}
          popUpMsg={popUpMsg.message}
          buttonText={t('Okay')}
          isOpen={showPopUp}
          onClose={closePopup}
          isSucessMessage={exitStaffStatus === STATUS.SUCCESS ? true : false}
        />
      )}
    </>
  );
};
